import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FakeText, Typography, Card, IconButton } from '@totalsoft/rocket-ui';
import EngineExternalSystemListComponent from './EngineExternalSystemListComponent';
import { ViewList } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const EngineExternalSystemListContainer = ({
  externalSystems,
  onSave,
  containerDispatcher,
  isReadOnly,
  validation,
  loading,
  dictionaryExternalSystemInterrogation
}) => {
  const { t } = useTranslation();

  const onAddNewEngineExternalSystem = () => {
    containerDispatcher({
      type: 'OnAddNewEngineExternalSystem'
    });
  };

  const onSaveEngineExternalSystems = () => {
    onSave('OnSaveEngineExternalSystems', {});
  };

  return loading ? (
    <FakeText lines={10} />
  ) : (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('EngineScoring.EngineScoringXExternalSystems.Title')}
      subheader={<Typography color='error'>{validation |> getErrors}</Typography>}
      actions={
        <>
          <IconButton
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Tooltips.EngineScoringGrid.AddInterval')}
            onClick={onAddNewEngineExternalSystem}
            disabled={isReadOnly}
          />
          <IconButton
            type='save'
            fontSize='medium'
            color='transparent'
            tooltip={t('SaveChanges')}
            onClick={onSaveEngineExternalSystems}
            disabled={!externalSystems.changed || isReadOnly || !(validation |> isValid) || externalSystems.saving}
          />
        </>
      }
    >
      <EngineExternalSystemListComponent
        containerDispatcher={containerDispatcher}
        dictionaryExternalSystemInterrogation={dictionaryExternalSystemInterrogation}
        externalSystems={externalSystems}
        isReadOnly={isReadOnly}
        loading={loading}
        validation={validation}
      />
    </Card>
  );
};

EngineExternalSystemListContainer.propTypes = {
  externalSystems: PropTypes.object.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  dictionaryExternalSystemInterrogation: PropTypes.array.isRequired
};

export default EngineExternalSystemListContainer;
